module.exports = __webpack_public_path__ + "aeff038c31a49f6b85dc86cd4d14ed61.svg";